import { render } from "./CarDetailsForSelection.vue?vue&type=template&id=51f1b4fe&scoped=true&ts=true"
import script from "./CarDetailsForSelection.vue?vue&type=script&lang=ts"
export * from "./CarDetailsForSelection.vue?vue&type=script&lang=ts"

import "./CarDetailsForSelection.vue?vue&type=style&index=0&id=51f1b4fe&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f1b4fe"]])

export default __exports__